<h1>Select Regional Ecosystem Statuses</h1>
<div class="preamble instructions">
  <p><abbr title="(required)" class="required">*</abbr>
  For each category, select the statuses that apply to the area you want to notify for
</p>
@if (form.hasError('statusRequiredValidationError')) {
  <div class="alert alert-warning mt-4" role="alert">
    <h2><i class="fa fa-exclamation-triangle"></i></h2>
    You must select at least one status for each category.
  </div>
}
@if (form.hasError('notificationBlockedValidationError')) {
  <div class="alert alert-warning mt-4" role="alert">
    <h2><i class="fa fa-exclamation-triangle"></i></h2>
    One or more of the regional ecosystem statuses you've selected is not permitted for clearing in this code. See
    messages below.
  </div>
}
</div>

<form [formGroup]="form" (submit)="next()" class="form">
  <ol class="questions">
    <li>
      <div formArrayName="regionalEcosystemStatusArray">
        @for (reStatusControl of getRegionalEcosystemStatusArray().controls; track reStatusControl; let reStatusGroupName = $index) {
          <div
            >
            <div [formGroupName]="reStatusGroupName">
              <label>
                <h3>{{reStatusControl.value.category}}</h3>
              </label>
              @for (statusControl of getStatusArray(reStatusControl).controls; track statusControl; let statusGroupName = $index) {
                <div formArrayName="statuses"
                  >
                  <fieldset>
                    <div [formGroupName]="statusGroupName">
                      <input type="checkbox" formControlName="checked"
                        id="status-{{statusControl.value.status.regionalEcosystemStatusId}}" />
                        <label for="status-{{statusControl.value.status.regionalEcosystemStatusId}}">
                          {{ statusControl.value.status.code }}
                          @if (statusControl.value.checked && !!statusControl.value.status.message && regionalEcosystemStatusData.messages.length > 0) {
                            <small
                              >
                              <sup>*{{regionalEcosystemStatusData.messages.indexOf(statusControl.value.status.message)
                              + 1}}</sup>
                            </small>
                          }
                        </label>
                      </div>
                    </fieldset>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </li>
    </ol>
    @if (regionalEcosystemStatusData.messages.length > 0) {
      <div class="alert alert-info mt-4" role="alert">
        <h2><i class="fa fa-info-circle"></i>Messages</h2>
        <ol>
          @for (message of regionalEcosystemStatusData.messages; track message) {
            <li>
              {{message}}
            </li>
          }
        </ol>
      </div>
    }

    <div class="footer">
      <ul class="actions">
        <li> <input class="qg-btn btn-global-secondary" type="button" (click)="previous()" value="Previous" /> </li>
        <li> <em> <input class="qg-btn btn-primary" type="submit"
        value="Next" in-progress-text="Saving..." /> </em> </li>
      </ul>
      <ul class="actions">
        <li>
          <a href="#" (click)="cancel()">Cancel</a>
        </li>
      </ul>
    </div>
  </form>
